//================================================================
//  Component: RequestPane
//================================================================

//  Purpose: This side pane allows a user to view a digital commercial request

//  Properties:
//    - paneOpen = { useState, holds a boolean value that opens and closes the sidePane}
//    - setPaneOpen = { useState, updates the boolean value that opens and closes the sidePane}
//    - selectedRequest = { useState, stores the currently selected request}
//    - setSelectedRequest = { useState, used to set the selected request }

//  Example:
//  
//    <RequestPane
//      paneOpen={openPane}
//      setPaneOpen={setOpenPane}
//      selectedRequest={selectedRequest}
//      setSelectedRequest={setSelectedRequest}
//    ></RequestPane>

//================================================================

// Libraries
import React from 'react';

// Contexts

// Functions

// Images
import FileIcon from '../Images/Icon_File_Black.svg';
import InfoRequired from '../Images/Icon_InfoRequired_Blue.svg';

export default function RequestPane({
    paneOpen,
    setPaneOpen,
    selectedRequest,
    setSelectedRequest
}) {

    //------------------------------------------------------
    //  useRef
    //------------------------------------------------------

    //------------------------------------------------------
    //  useEffect
    //------------------------------------------------------

    // --------------------------------------------------
    //  HTML
    // --------------------------------------------------

    // ==================================================
    //  Hide Side Pane
    // ==================================================

    if (!paneOpen) return null;

    // ==================================================
    //  Show Digital Commercial Request Form 
    // ==================================================

    else if (selectedRequest?.requestorigin === 'Digital') {
        return (
            <div className='Pane-Background'>
                <dialog className='Pane-Container'>
                    <div className='grid grid-rows-[70px_1fr_70px] items-center justify-between w-full overflow-hidden' >

                        {/* ===================================== */}
                        {/*  Header                               */}
                        {/* ===================================== */}

                        <div className='flex flex-col gap-2 p-4'>
                            <h4 className='text-[22px] p-0 m-0'> Digital Commercial Request | {selectedRequest?.poanumber.toUpperCase()} </h4>
                        </div>

                        {/* ===================================== */}
                        {/*  Form                                 */}
                        {/* ===================================== */}

                        <div className='w-[50vw] h-full flex flex-col overflow-y-auto p-4 px-4 border-solid border shadow-inner'>

                            {/* ------------- REQUEST INFORMATION ------------- */}

                            <h5 className='text-[18px] text-teal-600 mb-2'>Request Information</h5>

                            {/* =========================================================== */}
                            {/*  1. Request Type                                            */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 1. Request Type </label>
                                <input
                                    className='Input-Field-Text'
                                    type='text'
                                    value={selectedRequest?.requesttype}
                                    disabled
                                ></input>
                            </div>

                            {/* =========================================================== */}
                            {/*  2. Application Name                                        */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 2. Application Name </label>
                                <input
                                    className='Input-Field-Text'
                                    type='text'
                                    value={selectedRequest?.applicationname === '' ? '-' : selectedRequest?.applicationname}
                                    disabled
                                ></input>
                            </div>

                            {/* =========================================================== */}
                            {/*  3. Short Description                                       */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 3. Short Description </label>
                                <textarea
                                    className='Input-Field-TextArea'
                                    type='text'
                                    value={selectedRequest?.shortdescription}
                                    disabled
                                ></textarea>
                            </div>

                            {/* =========================================================== */}
                            {/*  4. What is the problem you are trying to solve?            */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 4. What is the problem you are trying to solve? </label>
                                <textarea
                                    className='Input-Field-TextArea'
                                    type='text'
                                    value={selectedRequest?.problemtosolve}
                                    disabled
                                ></textarea>
                            </div>

                            {/* =========================================================== */}
                            {/*  5. What is the outcome you are looking for?                */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 5. What is the outcome you are looking for? </label>
                                <textarea
                                    className='Input-Field-TextArea'
                                    type='text'
                                    value={selectedRequest?.expectedoutcome}
                                    disabled
                                ></textarea>
                            </div>

                            {/* =========================================================== */}
                            {/*  6. What would be the impact if this didn't go ahead?       */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 6. What would be the impact if this didn't go ahead? </label>
                                <textarea
                                    className='Input-Field-TextArea'
                                    type='text'
                                    value={selectedRequest?.expectedimpact}
                                    disabled
                                ></textarea>
                            </div>

                            {/* =========================================================== */}
                            {/*  7. Requester Name                                          */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 7. Requester Name </label>
                                <input
                                    className='Input-Field-Text'
                                    type='text'
                                    value={selectedRequest?.requestername}
                                    disabled
                                ></input>
                            </div>

                            {/* =========================================================== */}
                            {/*  8. Region                                                  */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 8. Region </label>
                                <input
                                    className='Input-Field-Text'
                                    style={{ width: '200px' }}
                                    type='text'
                                    value={selectedRequest?.region}
                                    disabled
                                ></input>
                            </div>

                            {/* =========================================================== */}
                            {/*  9. Sponsor Name                                            */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 9. Sponsor Name </label>
                                <select className='Input-Field-Select' disabled>
                                    <option>{selectedRequest?.sponsorname.email}</option>
                                </select>
                            </div>

                            {/* =========================================================== */}
                            {/*  10. Created By                                             */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 10. Created By </label>
                                <input
                                    className='Input-Field-Text'
                                    style={{ width: '300px' }}
                                    type='text'
                                    value={selectedRequest?.createdby?.email}
                                    disabled
                                ></input>
                            </div>

                            {/* =========================================================== */}
                            {/*  11. Supporting Documents                                   */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 11. Supporting Documents </label>
                                {
                                    selectedRequest?.supportingdocs.length === 0 ?
                                        (
                                            <div>
                                                No documents found.
                                            </div>
                                        )
                                        :
                                        (
                                            <table className='table-auto w-full border-separate border-spacing-0 border-1 border-solid border-[#D8D8D8] rounded-[10px]'>
                                                <thead>
                                                    <tr>
                                                        <th className='font-normal px-3 py-2'>Uploaded Documents</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        selectedRequest?.supportingdocs.map((file, index) => (
                                                            <tr key={index}>
                                                                <td className='flex flex-row gap-2 px-3 py-2 text-[#0972D3] underline border-t border-t-[#D8D8D8]'>
                                                                    <img src={FileIcon} alt='file'></img>
                                                                    <a href={file?.fileUrl} target='_blank' rel='noreferrer'>
                                                                        {file?.fileName}
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        )
                                }
                            </div>

                            {/* ------------- CONTRACT INFORMATION ------------- */}

                            <h5 className='text-[18px] text-teal-600 mt-4 mb-2'>Contract Information</h5>

                            {/* =========================================================== */}
                            {/*  12. Detailed Request / Scope Description                   */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium mb-0'> 12. Detailed Request / Scope Description </label>
                                <textarea
                                    className='Input-Field-TextArea'
                                    value={selectedRequest?.commercialscope}
                                    disabled
                                ></textarea>
                            </div>

                            {/* =========================================================== */}
                            {/*  13. Urgency                                                */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 13. Urgency </label>
                                <select className='Input-Field-Select' style={{ width: '200px' }} disabled>
                                    <option>{selectedRequest?.urgency}</option>
                                </select>
                            </div>   

                            {/* =========================================================== */}
                            {/*  14. Impact                                                 */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 14. Impact </label>
                                <select className='Input-Field-Select' style={{ width: '200px' }} disabled>
                                    <option>{selectedRequest?.impact}</option>
                                </select>
                            </div>   

                            {/* =========================================================== */}
                            {/*  15. Buy / Sell Agreement                                   */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 15. Is this a buy or sell agreement? </label>
                                <select className='Input-Field-Select' style={{ width: '200px' }} disabled>
                                    <option>{selectedRequest?.buysellagreement}</option>
                                </select>
                            </div>

                            {/* =========================================================== */}
                            {/*  16. Agreement Type                                         */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 16. Agreement Type </label>
                                <select className='Input-Field-Select' disabled>
                                    <option>{selectedRequest?.agreementtype}</option>
                                </select>
                            </div>

                            {/* =========================================================== */}
                            {/*  19. Lendlease Company                                      */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 17. Lendlease Company (Signing Entity) </label>
                                <select className='Input-Field-Select' disabled>
                                    <option>{selectedRequest?.lendleasecompany}</option>
                                </select>
                            </div>

                            {/* ------------- OTHER PARTY INFORMATION (VENDOR/CUSTOMER) ------------- */}

                            <h5 className='text-[18px] text-teal-600 mt-4 mb-2'> Other Party Information (Vendor / Customer) </h5>

                            {/* =========================================================== */}
                            {/*  18. Vendor Name                                            */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 18. Vendor Name </label>
                                {
                                    selectedRequest?.newvendorname?.length === 0 ?

                                        // Existing Vendor
                                        <input
                                            className='Input-Field-Text'
                                            type='text'
                                            value={selectedRequest?.vendor?.vendorname}
                                            disabled
                                        ></input>

                                        :

                                        // New Vendor
                                        <div className='flex flex-col justify-center bg-[#E7F0F4] px-4 py-3 rounded-md'>

                                            {/* Header */}
                                            <div className='flex flex-row gap-2 items-center'>
                                                <img src={InfoRequired} alt='info'></img>
                                                <label className='font-medium text-[#5E93AC]'>New Vendor Request</label>
                                            </div>

                                            {/* Form */}
                                            <div className='grid grid-cols-2 gap-2'>

                                                {/* Column 1 */}
                                                <div className='flex flex-col gap-2 px-2 mt-0 mb-2'>

                                                    {/* Vendor Name */}
                                                    <div className='Task-Form-Row'>
                                                        <label className='font-medium'> Vendor Name </label>
                                                        <input
                                                            className='Input-Field-Text'
                                                            style={{ width: '100%' }}
                                                            value={selectedRequest?.newvendorname}
                                                            type='text'
                                                            disabled
                                                        ></input>
                                                    </div>

                                                    {/* Vendor Phone */}
                                                    <div className='Task-Form-Row'>
                                                        <label className='font-medium'> Vendor Name </label>
                                                        <input
                                                            className='Input-Field-Text'
                                                            style={{ width: '100%' }}
                                                            value={selectedRequest?.newvendorcontactphone}
                                                            type='text'
                                                            disabled
                                                        ></input>
                                                    </div>

                                                </div>

                                                {/* Column 2 */}
                                                <div className='flex flex-col gap-2 px-2 mt-0 mb-2'>

                                                    {/* Vendor Trading As Name */}
                                                    <div className='Task-Form-Row'>
                                                        <label className='font-medium'> Vendor Trading As Name </label>
                                                        <input
                                                            className='Input-Field-Text'
                                                            style={{ width: '100%' }}
                                                            value={selectedRequest?.newvendortradingname}
                                                            type='text'
                                                            disabled
                                                        ></input>
                                                    </div>

                                                    {/* Vendor Email */}
                                                    <div className='Task-Form-Row'>
                                                        <label className='font-medium'> Vendor Email </label>
                                                        <input
                                                            className='Input-Field-Text'
                                                            style={{ width: '100%' }}
                                                            value={selectedRequest?.newvendorcontactemail}
                                                            type='text'
                                                            disabled
                                                        ></input>
                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                }
                            </div>

                            {/* ------------- FINANCIAL INFORMATION ------------- */}

                            <h5 className='text-[18px] text-teal-600 mt-4 mb-2' hidden={selectedRequest?.requesttype === 'Establish NDA'}> Financial Information </h5>

                            {/* =========================================================== */}
                            {/*  19. Budget Owner                                           */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row' hidden={selectedRequest?.requesttype === 'Establish NDA'}>
                                <label className='font-medium'> 19. Budget Owner </label>
                                <select className='Input-Field-Select' disabled>
                                    <option>{selectedRequest?.budgetowner?.givenname} {selectedRequest?.budgetowner?.surname}</option>
                                </select>
                            </div>

                            {/* =========================================================== */}
                            {/*  20. Finance Manager                                        */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row' hidden={selectedRequest?.requesttype === 'Establish NDA'}>
                                <label className='font-medium'> 20. Finance Manager </label>
                                <select className='Input-Field-Select' disabled>
                                    <option>{selectedRequest?.financemanager?.givenname} {selectedRequest?.financemanager?.surname}</option>
                                </select>
                            </div>

                            {/* =========================================================== */}
                            {/*  21. Currency                                               */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row' hidden={selectedRequest?.requesttype === 'Establish NDA' || selectedRequest?.requesttype === 'Assign/Novate Agreement' || selectedRequest?.requesttype === 'Terminate Existing Agreement'}>
                                <label className='font-medium'> 21. Currency </label>
                                <select className='Input-Field-Select' disabled>
                                    <option>{selectedRequest?.currency === '' ? '-' : selectedRequest?.currency}</option>
                                </select>
                            </div>

                            {/* =========================================================== */}
                            {/*  22. Estimated Annual Contract Value (exGST)                 */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row' hidden={selectedRequest?.requesttype === 'Establish NDA' || selectedRequest?.requesttype === 'Assign/Novate Agreement' || selectedRequest?.requesttype === 'Terminate Existing Agreement'}>
                                <label className='font-medium'> 22. Estimated Annual Contract Value (exGST) </label>
                                <input
                                    className='Input-Field-Text'
                                    style={{ width: '300px' }}
                                    type='text'
                                    value={selectedRequest?.estannualcontractvalue === '' ? '-' : selectedRequest?.estannualcontractvalue}
                                    disabled
                                ></input>
                            </div>

                            {/* =========================================================== */}
                            {/*  23. Estimated Total Contract Value (exGST)                  */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row' hidden={selectedRequest?.requesttype === 'Establish NDA' || selectedRequest?.requesttype === 'Assign/Novate Agreement' || selectedRequest?.requesttype === 'Terminate Existing Agreement'}>
                                <label className='font-medium'> 23. Estimated Total Contract Value (exGST) </label>
                                <input
                                    className='Input-Field-Text'
                                    style={{ width: '300px' }}
                                    type='text'
                                    value={selectedRequest?.esttotalcontractvalue === '' ? '-' : selectedRequest?.esttotalcontractvalue}
                                    disabled
                                ></input>
                            </div>

                    
                            {/* ============================ */}
                            {/*  24. Recharge Information *  */}
                            {/* ============================ */}
            
                            <div className='FormComponent-Row' hidden={selectedRequest?.requesttype === 'Establish NDA' || selectedRequest?.requesttype === 'Assign/Novate Agreement'}>
                                <label><b style={{ fontWeight: '500' }}> {selectedRequest?.requesttype === 'Terminate Existing Agreement' ? 21 : 24}. Recharge Information </b> </label>

                                <i className='mb-3'>Project code, task number and expenditure type allow the recharge of technology costs.</i>
                
                                {/* Project Code */}
                                <div className='flex flex-row'>
                                    <label className='w-[130px]'>Project Code</label>
                                    <input
                                        className='Input-Field-Text'
                                        type='text'
                                        placeholder={'Project Code'}
                                        value={selectedRequest?.projectcode === '' ? '-' : selectedRequest?.projectcode}
                                        disabled={true}
                                    ></input>
                                </div>

                                {/* Project Name */}
                                <div className='flex flex-row' hidden={selectedRequest?.projectcodename === '' || selectedRequest?.projectcodename === undefined}>
                                    <label className='w-[130px]'>Project Name</label>
                                    <input
                                        className='Input-Field-Text'
                                        type='text'
                                        placeholder={'Project Name'}
                                        value={selectedRequest?.projectcodename === '' ? '-' : selectedRequest?.projectcodename}
                                        disabled={true}
                                    ></input>
                                </div>

                                {/* Task Number */}
                                <div className='flex flex-row'>
                                    <label className='w-[130px]'>Task Number</label>
                                    <input
                                        className='Input-Field-Text'
                                        type='text'
                                        placeholder={'Task Number'}
                                        value={selectedRequest?.tasknumber === '' ? '-' : selectedRequest?.tasknumber}
                                        disabled={true}
                                    ></input>
                                </div>

                                {/* Expenditure Type */}
                                <div className='flex flex-row'>
                                    <label className='w-[130px]'>Expenditure Type</label>
                                    <input
                                        className='Input-Field-Text'
                                        type='text'
                                        placeholder={'Expenditure Type'}
                                        value={selectedRequest?.expendituretype === '' ? '-' : selectedRequest?.expendituretype}
                                        disabled={true}
                                    ></input>
                                </div>
                            </div>

                            
                        </div>

                        {/* ===================================== */}
                        {/*  Close Button                         */}
                        {/* ===================================== */}

                        <div className='px-4 py-3'>
                            <button className='Primary-Button' onClick={() => {

                                // Reset Selected Request
                                setSelectedRequest();

                                // Close Side Pane
                                setPaneOpen(false);

                            }}>
                                Close
                            </button>
                        </div>

                    </div>
                </dialog>
            </div>
        )
    }

    // ==================================================
    //  Show Demand Commercial Request Form  
    // ==================================================

    else {
        return (
            <div className='Pane-Background'>
                <dialog className='Pane-Container'>
                    <div className='grid grid-rows-[70px_1fr_70px] items-center justify-between w-full overflow-hidden' >

                        {/* ===================================== */}
                        {/*  Header                               */}
                        {/* ===================================== */}

                        <div className='flex flex-col gap-2 p-4'>
                            <h4 className='text-[22px] p-0 m-0'> Demand Commercial Request | {selectedRequest?.poanumber.toUpperCase()} </h4>
                        </div>

                        {/* ===================================== */}
                        {/*  Form                                 */}
                        {/* ===================================== */}

                        <div className='w-[50vw] h-full flex flex-col overflow-y-auto p-4 px-4 border-solid border shadow-inner'>

                            {/* ------------- REQUEST INFORMATION ------------- */}

                            <h5 className='text-[18px] text-teal-600 mb-2'>Request Information</h5>

                            {/* =========================================================== */}
                            {/*  1. Request Type                                            */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 1. Request Type </label>
                                <input
                                    className='Input-Field-Text'
                                    type='text'
                                    value={selectedRequest?.requesttype}
                                    disabled
                                ></input>
                            </div>

                            {/* =========================================================== */}
                            {/*  2. Application Name                                        */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 2. Application Name </label>
                                <input
                                    className='Input-Field-Text'
                                    type='text'
                                    value={selectedRequest?.applicationname}
                                    disabled
                                ></input>
                            </div>

                            {/* =========================================================== */}
                            {/*  3. Short Description                                       */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 3. Short Description </label>
                                <textarea
                                    className='Input-Field-TextArea'
                                    type='text'
                                    value={selectedRequest?.shortdescription}
                                    disabled
                                ></textarea>
                            </div>

                            {/* =========================================================== */}
                            {/*  4. Requester Name                                          */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 4. Requester Name </label>
                                <input
                                    className='Input-Field-Text'
                                    type='text'
                                    value={selectedRequest?.requestername}
                                    disabled
                                ></input>
                            </div>

                            {/* =========================================================== */}
                            {/*  5. Region                                                  */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 5. Region </label>
                                <input
                                    className='Input-Field-Text'
                                    style={{ width: '200px' }}
                                    type='text'
                                    value={selectedRequest?.region}
                                    disabled
                                ></input>
                            </div>

                            {/* =========================================================== */}
                            {/*  6. Sponsor Name                                            */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 6. Sponsor Name </label>
                                <select className='Input-Field-Select' disabled>
                                    <option>{selectedRequest?.sponsorname.email}</option>
                                </select>
                            </div>

                            {/* =========================================================== */}
                            {/*  7. Created By                                              */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 7. Created By </label>
                                <input
                                    className='Input-Field-Text'
                                    style={{ width: '300px' }}
                                    type='text'
                                    value={selectedRequest?.createdby?.email}
                                    disabled
                                ></input>
                            </div>

                            {/* =========================================================== */}
                            {/*  8. Supporting Documents                                    */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 8. Supporting Documents </label>
                                {
                                    selectedRequest?.supportingdocs.length === 0 ?
                                        (
                                            <div>
                                                No documents found.
                                            </div>
                                        )
                                        :
                                        (
                                            <table className='table-auto w-full border-separate border-spacing-0 border-1 border-solid border-[#D8D8D8] rounded-[10px]'>
                                                <thead>
                                                    <tr>
                                                        <th className='font-normal px-3 py-2'>Uploaded Documents</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        selectedRequest?.supportingdocs.map((file, index) => (
                                                            <tr key={index}>
                                                                <td className='flex flex-row gap-2 px-3 py-2 text-[#0972D3] underline border-t border-t-[#D8D8D8]'>
                                                                    <img src={FileIcon} alt='file'></img>
                                                                    <a href={file?.fileUrl} target='_blank' rel='noreferrer'>
                                                                        {file?.fileName}
                                                                    </a>
                                                                </td>
                                                            </tr>
                                                        ))
                                                    }
                                                </tbody>
                                            </table>
                                        )
                                }
                            </div>

                            {/* ------------- CONTRACT INFORMATION ------------- */}

                            <h5 className='text-[18px] text-teal-600 mt-4 mb-2'>Contract Information</h5>

                            {/* =========================================================== */}
                            {/*  9. Commercial Scope                                        */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium mb-0'> 9. Commercial Scope Description </label>
                                <textarea
                                    className='Input-Field-TextArea'
                                    value={selectedRequest?.commercialscope}
                                    disabled
                                ></textarea>
                            </div>

                            {/* =========================================================== */}
                            {/*  10. Urgency                                                */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 10. Urgency </label>
                                <select className='Input-Field-Select' style={{ width: '200px' }} disabled>
                                    <option>{selectedRequest?.urgency}</option>
                                </select>
                            </div>   

                            {/* =========================================================== */}
                            {/*  11. Impact                                                 */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 11. Impact </label>
                                <select className='Input-Field-Select' style={{ width: '200px' }} disabled>
                                    <option>{selectedRequest?.impact}</option>
                                </select>
                            </div>   

                            {/* =========================================================== */}
                            {/*  12. Buy / Sell Agreement                                   */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 12. Is this a buy or sell agreement? </label>
                                <select className='Input-Field-Select' style={{ width: '200px' }} disabled>
                                    <option>{selectedRequest?.buysellagreement}</option>
                                </select>
                            </div>

                            {/* =========================================================== */}
                            {/*  13. Agreement Type                                         */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 13. Agreement Type </label>
                                <select className='Input-Field-Select' disabled>
                                    <option>{selectedRequest?.agreementtype}</option>
                                </select>
                            </div>

                            {/* =========================================================== */}
                            {/*  14. Lendlease Company                                      */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 14. Lendlease Company (Signing Entity) </label>
                                <select className='Input-Field-Select' disabled>
                                    <option>{selectedRequest?.lendleasecompany}</option>
                                </select>
                            </div>

                            {/* ------------- OTHER PARTY INFORMATION (VENDOR/CUSTOMER) ------------- */}

                            <h5 className='text-[18px] text-teal-600 mt-4 mb-2'> Other Party Information (Vendor / Customer) </h5>

                            {/* =========================================================== */}
                            {/*  15. Vendor Name                                            */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 15. Vendor Name </label>
                                {
                                    selectedRequest?.newvendorname?.length === 0 ?

                                        // Existing Vendor
                                        <input
                                            className='Input-Field-Text'
                                            type='text'
                                            value={selectedRequest?.vendor?.vendorname}
                                            disabled
                                        ></input>

                                        :

                                        // New Vendor
                                        <div className='flex flex-col justify-center bg-[#E7F0F4] px-4 py-3 rounded-md'>

                                            {/* Header */}
                                            <div className='flex flex-row gap-2 items-center'>
                                                <img src={InfoRequired} alt='info'></img>
                                                <label className='font-medium text-[#5E93AC]'>New Vendor Request</label>
                                            </div>

                                            {/* Form */}
                                            <div className='grid grid-cols-2 gap-2'>

                                                {/* Column 1 */}
                                                <div className='flex flex-col gap-2 px-2 mt-0 mb-2'>

                                                    {/* Vendor Name */}
                                                    <div className='Task-Form-Row'>
                                                        <label className='font-medium'> Vendor Name </label>
                                                        <input
                                                            className='Input-Field-Text'
                                                            style={{ width: '100%' }}
                                                            value={selectedRequest?.newvendorname}
                                                            type='text'
                                                            disabled
                                                        ></input>
                                                    </div>

                                                    {/* Vendor Phone */}
                                                    <div className='Task-Form-Row'>
                                                        <label className='font-medium'> Vendor Name </label>
                                                        <input
                                                            className='Input-Field-Text'
                                                            style={{ width: '100%' }}
                                                            value={selectedRequest?.newvendorcontactphone}
                                                            type='text'
                                                            disabled
                                                        ></input>
                                                    </div>

                                                </div>

                                                {/* Column 2 */}
                                                <div className='flex flex-col gap-2 px-2 mt-0 mb-2'>

                                                    {/* Vendor Trading As Name */}
                                                    <div className='Task-Form-Row'>
                                                        <label className='font-medium'> Vendor Trading As Name </label>
                                                        <input
                                                            className='Input-Field-Text'
                                                            style={{ width: '100%' }}
                                                            value={selectedRequest?.newvendortradingname}
                                                            type='text'
                                                            disabled
                                                        ></input>
                                                    </div>

                                                    {/* Vendor Email */}
                                                    <div className='Task-Form-Row'>
                                                        <label className='font-medium'> Vendor Email </label>
                                                        <input
                                                            className='Input-Field-Text'
                                                            style={{ width: '100%' }}
                                                            value={selectedRequest?.newvendorcontactemail}
                                                            type='text'
                                                            disabled
                                                        ></input>
                                                    </div>

                                                </div>

                                            </div>

                                        </div>
                                }
                            </div>

                            {/* ------------- FINANCIAL INFORMATION ------------- */}

                            <h5 className='text-[18px] text-teal-600 mt-4 mb-2'> Financial Information </h5>

                            {/* =========================================================== */}
                            {/*  16. Currency                                               */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 16. Currency </label>
                                <select className='Input-Field-Select' disabled>
                                    <option>{selectedRequest?.currency === '' ? '-' : selectedRequest?.currency}</option>
                                </select>
                            </div>

                            {/* =========================================================== */}
                            {/*  17. Estimated Annual Contract Value (exGST)                 */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 17. Estimated Annual Contract Value (exGST) </label>
                                <input
                                    className='Input-Field-Text'
                                    style={{ width: '300px' }}
                                    type='text'
                                    value={selectedRequest?.estannualcontractvalue === '' ? '-' : selectedRequest?.estannualcontractvalue}
                                    disabled
                                ></input>
                            </div>

                            {/* =========================================================== */}
                            {/*  18. Estimated Total Contract Value (exGST)                  */}
                            {/* =========================================================== */}

                            <div className='FormComponent-Row'>
                                <label className='font-medium'> 18. Estimated Total Contract Value (exGST) </label>
                                <input
                                    className='Input-Field-Text'
                                    style={{ width: '300px' }}
                                    type='text'
                                    value={selectedRequest?.esttotalcontractvalue === '' ? '-' : selectedRequest?.esttotalcontractvalue}
                                    disabled
                                ></input>
                            </div>

                            {/* ============================ */}
                            {/*  19. Recharge Information *  */}
                            {/* ============================ */}
            
                            <div className='FormComponent-Row'>
                                <label><b style={{ fontWeight: '500' }}> 19. Recharge Information </b> </label>

                                <i className='mb-3'>Project code, task number and expenditure type allow the recharge of technology costs.</i>
                
                                {/* Project Code */}
                                <div className='flex flex-row'>
                                    <label className='w-[130px]'>Project Code</label>
                                    <input
                                        className='Input-Field-Text'
                                        type='text'
                                        placeholder={'Project Code'}
                                        value={selectedRequest?.projectcode === '' ? '-' : selectedRequest?.projectcode}
                                        disabled={true}
                                    ></input>
                                </div>

                                {/* Project Name */}
                                <div className='flex flex-row' hidden={selectedRequest?.projectcodename === '' || selectedRequest?.projectcodename === undefined}>
                                    <label className='w-[130px]'>Project Name</label>
                                    <input
                                        className='Input-Field-Text'
                                        type='text'
                                        placeholder={'Project Name'}
                                        value={selectedRequest?.projectcodename === '' ? '-' : selectedRequest?.projectcodename}
                                        disabled={true}
                                    ></input>
                                </div>

                                {/* Task Number */}
                                <div className='flex flex-row'>
                                    <label className='w-[130px]'>Task Number</label>
                                    <input
                                        className='Input-Field-Text'
                                        type='text'
                                        placeholder={'Task Number'}
                                        value={selectedRequest?.tasknumber === '' ? '-' : selectedRequest?.tasknumber}
                                        disabled={true}
                                    ></input>
                                </div>

                                {/* Expenditure Type */}
                                <div className='flex flex-row'>
                                    <label className='w-[130px]'>Expenditure Type</label>
                                    <input
                                        className='Input-Field-Text'
                                        type='text'
                                        placeholder={'Expenditure Type'}
                                        value={selectedRequest?.expendituretype === '' ? '-' : selectedRequest?.expendituretype}
                                        disabled={true}
                                    ></input>
                                </div>
                            </div>

                            
                        </div>

                        {/* ===================================== */}
                        {/*  Close Button                         */}
                        {/* ===================================== */}

                        <div className='px-4 py-3'>
                            <button className='Primary-Button' onClick={() => {

                                // Reset Selected Request
                                setSelectedRequest();

                                // Close Side Pane
                                setPaneOpen(false);

                            }}>
                                Close
                            </button>
                        </div>

                    </div>
                </dialog>
            </div>
        );
    }

}
